import { render, staticRenderFns } from "./product_edit.vue?vue&type=template&id=eb56190e&scoped=true"
import script from "./product_edit.vue?vue&type=script&lang=js"
export * from "./product_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb56190e",
  null
  
)

export default component.exports